var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.visible,"class-name":"ik-loading-overlay"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('van-loading',{attrs:{"type":"spinner","size":"24px","color":"rgba(0,0,0,.7)","vertical":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }